import React from 'react';

import Header4 from '../../components/header/header4/Header4';
import ServicesHeroSection from '../../components/services_hero_section/ServicesHeroSection';
import Footer from '../../components/footer/Footer';
import backgroundimg from '../../assets/images/environmrnt-1.jpg';
import ServicesOverviewSection from '../../components/services_overview_section/ServicesOverviewSection';
import img_environmental_banner from '../../assets/images/img_peso1_banner.png'; // Replace with an appropriate image path
import { FaLeaf, FaRegFileAlt, FaHandsHelping, FaSearchLocation, FaFileSignature, FaComments, FaPaperPlane, FaCheckCircle } from 'react-icons/fa';
import ServicesBenefitsSection from '../../components/services_benefits_section/ServicesBenefitsSection';
import ServicesOurProcessSection from '../../components/services_our_process_section/ServicesOurProcessSection';
import ActsAndRulesSection from '../../components/acts_rules_section/ActsAndRulesSection';
import DocumentChecklist from '../../components/check_list_section/CheckListSection';

export default function EnvironmentalClearanceCompliance() {
  const benefits = [
    {
      icon: <FaLeaf />,
      title: 'Environmental Protection',
      text: 'Ensure minimal environmental impact while pursuing development projects.',
    },
    {
      icon: <FaRegFileAlt />,
      title: 'Regulatory Compliance',
      text: 'Avoid project delays and penalties by adhering to environmental laws.',
    },
    {
      icon: <FaHandsHelping />,
      title: 'Stakeholder Confidence',
      text: 'Show commitment to environmental sustainability and earn trust.',
    },
    {
      icon: <FaSearchLocation />,
      title: 'Sustainable Development',
      text: 'Align projects with eco-friendly principles and long-term goals.',
    },
  ];

  const steps = [
    {
      icon: <FaComments />,
      title: 'Initial Consultation',
      description: 'Understand project requirements and identify environmental clearance needs.',
    },
    {
      icon: <FaFileSignature />,
      title: 'Documentation Preparation',
      description: 'Prepare detailed project reports, environmental impact studies, and other documents.',
    },
    {
      icon: <FaSearchLocation />,
      title: 'Site Assessment',
      description: 'Facilitate site inspections and environmental assessments as required.',
    },
    {
      icon: <FaPaperPlane />,
      title: 'Submission and Follow-up',
      description: 'Submit applications to regulatory authorities and track progress until approval.',
    },
    {
      icon: <FaCheckCircle />,
      title: 'Final Clearance',
      description: 'Secure the necessary environmental clearance for your project.',
    },
  ];

  const acts = [
    'Environment Protection Act, 1986',
    'EIA Notification, 2006',
    'Air (Prevention and Control of Pollution) Act, 1981',
    'Water (Prevention and Control of Pollution) Act, 1974',
    'Hazardous Waste (Management and Handling) Rules, 1989',
  ];

  const explanation =
    'Environmental Clearance Compliance ensures that development activities align with legal requirements to protect the environment. It focuses on sustainable growth, safeguarding natural resources, and mitigating ecological impacts while adhering to the Environment Protection Act and related regulations.';

  const checklistItems = [
    { name: 'Project Report', description: 'Comprehensive project details, including objectives and scope.' },
    { name: 'Environmental Impact Assessment (EIA)', description: 'Detailed report on environmental effects and mitigation measures.' },
    { name: 'Consent Letters', description: 'Approvals or NOCs from relevant authorities and stakeholders.' },
    { name: 'Pollution Control Plans', description: 'Measures to control air, water, and soil pollution.' },
    { name: 'Risk Assessment Reports', description: 'Reports on potential risks and emergency management strategies.' },
  ];

  return (
    <>
      <Header4 />
      <ServicesHeroSection
        headline="Environmental Clearance Compliance Services"
        subheading="Expert guidance for obtaining environmental clearances and ensuring legal adherence."
        ctaPrimary={{ text: 'Request Consultation', link: '/contact-us' }}
        ctaSecondary={{ text: 'Learn More', link: '/environment-clearance-compliance' }}
        backgroundImage={backgroundimg} // Pass the background image here
      />

      <ServicesOverviewSection
        title="What is Environmental Clearance Compliance?"
        description="Environmental Clearance Compliance is mandatory for projects impacting natural resources. We assist in navigating the approval process, ensuring adherence to regulations while promoting sustainable development."
        image={img_environmental_banner} // Replace with a relevant image
        altText="Environmental Clearance Compliance"
      />

      <ServicesBenefitsSection
        title="Why Environmental Clearance Compliance Matters?"
        description="Understand the importance of environmental compliance and its role in sustainable development."
        benefits={benefits}
      />

      <ActsAndRulesSection
        title="Acts and Rules Covered"
        subtitle="Key Legal Frameworks for Environmental Clearance Compliance"
        acts={acts}
        explanation={explanation}
      />

      <ServicesOurProcessSection
        title="Our Environmental Clearance Process"
        steps={steps}
      />

      <DocumentChecklist
        mainTitle="Complete Your Onboarding"
        checklistTitle="Environmental Clearance Compliance Document Checklist"
        items={checklistItems}
      />

      <Footer />
    </>
  );
}
